<script>
import baseList from "@/views/components/base/baseList.vue";
export default {
  extends: baseList,
  components: {
    Image,
  },
  data() {
    return {
      commoditytype:'分类管理',
      table: {
        mname: "commodityType",
        key: "id",
        url: {
          del: "/admin/commodityType/delete",
        },
        output: false,
        order:'id',
        qrCode: "qrCode",
      },
      actions: [
        {
          label: "新增分类",
          icon: "md-add",
          onClick: this.toAdd,
          auth: "/admin/commodityType/add",
          type: "info",
          style:"",
        },
      ],
      menus: [
      // { label: "商品管理", name: "commodity_list", auth: "/admin/commodity/list"},
      //   { label: "分类管理", name: "commodityType_list", auth: "/admin/commodityType/list"},
      //   { label: "标签管理", name: "labelType_list", auth: "/admin/labelType/list"},
      //   { label: "日志管理", name: "logType_list", auth: "/admin/logType/list"},
      //   { label: "物流管理", name: "logisticsType_list", auth: "/admin/logisticsType/list"},
      //   { label: "订单管理", name: "ordersType_list", auth: "/admin/ordersType/list"},
      ],
      query: {
        //state: 2,
      },
      filters: [
      {label: '分类名称', name: 'commodityType', value: '', type: 'input'},
        // { label: "商品名称", name: "commodityName", value: "", type: "select" },
        // {
        //   label: "标签分类",
        //   name: "commodityType",
        //   value: "",
        //   type: "select",
        //   dropList: [
        //     { value: 1, name: "医用耗材" },
        //     { value: 2, name: "电子设备" },
        //   ],
        // },
      ],
      tableCols: [
        // {
        //   type: "selection",
        //   width: 60,
        // },
        // {
        //   title: "ID",
        //   key: "id",
        //   minWidth: 120,
        //   align: "left",
        // },
        // {
        //   title: "客户ID",
        //   key: "id",
        //   minWidth: 160,
        //   align: "left",
        // },
        {
          title: "分类名称",
          key: "commodityType",
          minWidth: 100,

          align: "center",
          // render: (h, params) => {
          //   const row = params.row;
          //   const text =
          //       row.id == 1
          //           ? "商品管理"
          //           : row.id == 2
          //               ? "分类管理"
          //               : "";
          //   return h(
          //       "div",text
          //   );
          // },
        },
        {
          title: "分类详细",
          key: "detail",
          minWidth: 350,

          align: "left",
          // render:()=>{
          //   return <p style="margin:15px;padding:15px">此分类涵盖了商品上传，商品名称编辑，商品价格和商品进货价调整，商品详细页上传，订单管理，订单发货管理</p>
          // }
        },
        {
          title: "分类创建人",
          key: "createBy",
          minWidth: 160,

          align:"center",
          // render:()=>{
          //   return <p>张三</p>
          // }
        },
        {
          title: "分类创建时间",
          key: "createTime",
          minWidth: 160,

          align: "center",
          // render:()=>{
          //   return <p>2022.09.15  18.00</p>
          // }
        },
        {
          title: "操作",
          align: "center",
          width: 260,

          key: "handle",
          handle: [
        
            "edit",
            "delete"
          ],
          auth: {
            edit: "/admin/commodityType/edit",
            del: "/admin/commodityType/delete",
          }
          // render:()=>{
          //     return (            
          //       <Space direction="vertical">
          //         <Space wrap>
          //             <Button>编辑</Button>
          //             <Button type="error" style="margin-left:10px">删除</Button>
          //         </Space>
          //     </Space>
          //     )
          // }
        },
      ],
    };
  },
  created() {
  },
  methods: {
    //选中
    // handleSelect(selected) {
    //   let ids_arr = [];
    //   let arry = [];
    //   for (let index = 0; index < selected.length; index++) {
    //     const element = selected[index];
    //     ids_arr.push(element[this.table.key]);
    //     arry.push(element[this.table.qrCode]);
    //   }
    //   this.selected = ids_arr.join(",");
    //   this.arrys = arry;
    // },
    toAdd() {
      $utils.url.push({ name: "commodityType_add", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "commodityType_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
  },
};
</script>

